import { Button } from "core/components/form-controls";
import { _t } from "core/language";
import { AddIngredientByImageSwiperButton } from "modules/AiChef/components";
import React, { memo } from "react";
import WhileCamera from "../assets/icon/while-camera.svg";
import BackgroundPhoto from "../assets/images/bg-main.png";
import RightPhoto from "../assets/images/right-main-cook.svg";
import { useSearchParams } from "react-router-dom";
import MainHeader from "core/components/Header/MainHeader";
import { LanguageCode } from "core/constants";

const PhotoRegistration: React.FC = () => {
  useSearchParams();
  const langCurrent = (window as any)._APP_LANG
  return (
    <section className="relative z-10 h-[260px] justify-center w-full text-center text-white aspect-[1.029]">
      <img
        className="object-cover absolute inset-0 size-full w-full h-[260px]"
        src={BackgroundPhoto}
        alt=""
      />
      <div className="relative w-full h-full">
        <MainHeader />
        <div className="grid grid-cols-2">
          <div className="absolute bottom-[60px] left-4">
            <h1
              className="text-[15px] font-bold text-left relative z-10"
              dangerouslySetInnerHTML={{
                __html: _t("main.photo_registration_title"),
              }}
            />
            <AddIngredientByImageSwiperButton>
              <Button
                classBtn={`mt-4 
                  md:w-auto 
                  [box-shadow:none!important] 
                  w-[170px] 
                  font-medium 
                  px-4 
                  text-left 
                  ${langCurrent === LanguageCode.ko ? ' whitespace-nowrap ' : ''}`
                }
                icon={WhileCamera}
                iconClassName="mr-1"
                rounded
                primary
                size="sm"
                label={_t("main.btn_add_photo")}
              />
            </AddIngredientByImageSwiperButton>
            {/* <p
              className="text-[14px] font-normal tracking-[-0.05em] mt-2.5"
              dangerouslySetInnerHTML={{
                __html: _t("main.photo_registration_content"),
              }}
            /> */}
          </div>
          <div className="w-[170px] absolute bottom-5 right-0">
            <img
              className="object-cover w-full h-full"
              src={RightPhoto}
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(PhotoRegistration);
